import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

const ResponsiveHomeDiv = styled.div`
  padding: 0 25%;
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  @media only screen and (max-width: 768px) {
    padding: 0 5%;
  }

  div {
    text-align: center;
    a {
      color: #686868;
      text-decoration: none;
      &:hover {
        text-decoration: none;
      }
    }
  }
`;

const NotFound = () => (
  <ResponsiveHomeDiv>
    <div>
      <h2 className="m-b-1 body">Page not found.</h2>
      <Link className="body" to="/">
        Go home
      </Link>
    </div>
  </ResponsiveHomeDiv>
);

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/NotFound.jsx